/**
 * Created by Administrator on 2017/10/16.
 */
import {GLOBAL_VARIABLE} from '../mutations-types';
// test 单个内容
const defaultTest = {
  content:0
};

// 中转页面全局变量
const defaultTrade = {
  trade:0
};

// 首页tab
const defaultCache = {
  homeTab:0,
  filmTabActive:0
};
// 影院详情轮播
const defaultJump = {
  actionJumpIndex:0,
  actionJumpTrue:0
};
// 影片tab下拉数量
const defaultFilm = {
  paramsIndex:10,
  waitIndex:10
};
// 影院选择
const defaultCinema = {
  userSelection:0,
  region:0,
  areaIndex:0,
  rank:0,
  selectDefault:0
};
// 影院排序
const defaultRank = {
  userArea:0,
  userSort:0
};
// 活动信息
const defaultActivity = {
  codeEnabled:0,
  filmUrl:'',
  gonggao:'',
  huodong:'',
  isActivity:0,
  sanpin:'',
  tip:'',
  xuanfu:''
};

// 汇总
const GlobalVariableModule = {
  state: {
    test:defaultTest,
    tradePayed:defaultTrade,
    cache: defaultCache,
    jump: defaultJump,
    film:defaultFilm,
    cinema:defaultCinema,
    rank:defaultRank,
    activity:defaultActivity
  },
  mutations: {
    [GLOBAL_VARIABLE.UPDATE_TEST](state, test = defaultTest){
      if (!test){
        test = defaultTest;
      }
      state.test = {
        ...test
      };
    },
    [GLOBAL_VARIABLE.UPDATE_TRADE](state, trade = defaultTrade){
      if (!trade){
        trade = defaultTrade;
      }
      state.trade = {
        ...trade
      };
    },
    [GLOBAL_VARIABLE.UPDATE_CACHE](state, cache = defaultCache){
      if (!cache) {
        cache = defaultCache;
      }
      state.cache = {
        ...cache
      };
    },
    [GLOBAL_VARIABLE.UPDATE_JUMP](state, jump = defaultJump){
      if (!jump) {
        jump = defaultJump;
      }
      state.jump = {
        ...jump
      };
    },
    [GLOBAL_VARIABLE.UPDATE_FILM](state, film = defaultFilm){
      if (!film) {
        film = defaultFilm;
      }
      state.film = {
        ...film
      };
    },
    [GLOBAL_VARIABLE.UPDATE_CINEMA](state, cinema = defaultCinema){
      if (!cinema) {
        cinema = defaultCinema;
      }
      state.cinema = {
        ...cinema
      };
    },
    [GLOBAL_VARIABLE.UPDATE_RANK](state, rank = defaultRank){
      if (!rank) {
        rank = defaultRank;
      }
      state.rank = {
        ...rank
      };
    },
    [GLOBAL_VARIABLE.UPDATE_ACTIVITY](state, activity = defaultActivity){
      if (!activity) {
        activity = defaultActivity;
      }
      state.activity = {
        ...activity
      };
    }
  }
}

export default GlobalVariableModule;
